var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoraaniQaaidah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.646,
    height: 220.18,
    viewBox: "0 0 186.646 220.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7956",
    "data-name": "Group 7956",
    transform: "translate(24669.914 21452.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7955",
    "data-name": "Group 7955",
    transform: "translate(-24668.414 -21450.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3647",
    "data-name": "Rectangle 3647",
    width: 162.063,
    height: 215.966,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39259",
    "data-name": "Path 39259",
    d: "M305.017,255.943s2.884-.8,15.626-5.552V45.755s-8.752-2.829-15.626-5.75Z",
    transform: "translate(-136.997 -39.974)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7937",
    "data-name": "Group 7937",
    transform: "translate(143.182 181.763)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1601",
    "data-name": "Line 1601",
    x1: 15.107,
    transform: "translate(3.777 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1602",
    "data-name": "Line 1602",
    x1: 18.884,
    transform: "translate(0 16.194)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7938",
    "data-name": "Group 7938",
    transform: "translate(0.002 18.01)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1603",
    "data-name": "Line 1603",
    x2: 15.107,
    transform: "translate(0 16.194)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1604",
    "data-name": "Line 1604",
    x2: 18.884,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1605",
    "data-name": "Line 1605",
    x1: 6.623,
    y2: 6.572,
    transform: "translate(32.727 98.361)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1606",
    "data-name": "Line 1606",
    x1: 7.009,
    y2: 7.008,
    transform: "translate(104.899 80.483)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1607",
    "data-name": "Line 1607",
    x1: 7.009,
    y2: 7.008,
    transform: "translate(96.262 79.651)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1608",
    "data-name": "Line 1608",
    x1: 7.009,
    y2: 7.008,
    transform: "translate(49.928 158.566)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1609",
    "data-name": "Line 1609",
    x1: 7.009,
    y2: 7.008,
    transform: "translate(41.291 157.734)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1653",
    "data-name": "Line 1653",
    y2: 55.654,
    transform: "translate(135.514 54.934)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1654",
    "data-name": "Line 1654",
    y2: 36.226,
    transform: "translate(135.514 117.142)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1655",
    "data-name": "Line 1655",
    y2: 46.564,
    transform: "translate(56.937 64.03)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39344",
    "data-name": "Path 39344",
    d: "M357.845,50.572V95.878H305.8V105.5H286.463",
    transform: "translate(-233.033 14.721)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3650",
    "data-name": "Rectangle 3650",
    width: 14.809,
    height: 14.953,
    transform: "translate(96.262 95.634)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39345",
    "data-name": "Path 39345",
    d: "M302.753,55.165V81.724H281.881V66.441",
    transform: "translate(-256.755 38.498)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39346",
    "data-name": "Path 39346",
    d: "M321.07,58.968V95.194h-27.5v-15.3l14.759-15.856",
    transform: "translate(-196.258 58.181)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39347",
    "data-name": "Path 39347",
    d: "M335.73,64.83H308.748v9.763h-21.11",
    transform: "translate(-226.957 88.525)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39348",
    "data-name": "Path 39348",
    d: "M309.334,61.8V80.5h-14.8V69.953H282.722V80.5h11.809",
    transform: "translate(-252.399 72.852)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39349",
    "data-name": "Path 39349",
    d: "M281.881,73.586V64.83h8.165",
    transform: "translate(-256.755 88.524)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoraaniQaaidah);
export default __webpack_public_path__ + "static/media/Noraani_Qaaidah.a8d3451c1d6d0dfae1b7e6b33399fe1b.svg";
export { ForwardRef as ReactComponent };